import Styled from "@emotion/styled";
import Grid from "@mui/material/Grid";
import ContactAgentDialog from "@components/contact-agent-dialog";
import { useState } from "react";
import WsContactGroup from "@components/ws-contact-group";
import useDataLayerEvent from "custom-hooks/data-layer-event.hook";

function ContactSection(props: any) {
  const [open, setOpen] = useState(false);
  const { event } = useDataLayerEvent();
  const { profileInfo } = props;
  const hiddenContact = [
    9, // wilton
  ].includes(profileInfo.id);

  const handleClose = () => {
    setOpen(!open);
  };

  const ClickWhatsAppAgent = () => {
    event({
      event_name: "whatsapp_contact_agent",
      body: {
        id_agente: profileInfo.id,
      },
    });
  };

  const ClickPhoneAgent = () => {
    event({
      event_name: "phone_contact_agent",
      body: {
        id_agente: profileInfo.id,
      },
    });
  };

  const ClickEmailAgent = () => {
    event({
      event_name: "email_contact_agent",
      body: {
        id_agente: profileInfo.id,
      },
    });
  };

  return (
    <Grid item md={4} xs={12}>
      {!hiddenContact && (
        <WsContactGroup
          phone={profileInfo.mobile || profileInfo.phone || profileInfo.phone2}
          whatsapp={
            profileInfo.mobile || profileInfo.phone || profileInfo.phone2
          }
          email={profileInfo.email}
          wsClick={() => ClickWhatsAppAgent()}
          phoneClick={() => ClickPhoneAgent()}
          emailClick={() => handleClose()}
        />
      )}

      <ContactAgentDialog
        open={open}
        onClose={handleClose}
        entity_info={profileInfo}
        isAgency={false}
        classNameModalButton="enviar-formulario-contacto-agente"
        customClass="agent"
        onCallBackSubmitEnd={() => {
          ClickEmailAgent();
        }}
      />
    </Grid>
  );
}

export default ContactSection;

const ContactInfoContent = Styled.div`
    justify-self: flex-end;
    margin-left: auto;
    @media screen and (max-width: 991px) {
        margin-right: 0;        
    }
     @media screen and (max-width: 767px) {
        margin-right: auto;        
    }
`;

const ContactInfoText = Styled.p`
    font-size: 1rem;
    font-weight: 600;
    color: #262b30;
    border-top: 1px solid #CBCBCB;
    border-bottom: 1px solid #CBCBCB;
    padding: 15px 20px;
    margin-bottom: 20px;
    text-align: center;
`;

const ContainerButton = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    a {
        margin:5px 0px;
    }   
`;

const ContentInfo = Styled.ul`
    list-style: none;
    
    @media screen and (max-width: 767px) {
        margin-bottom: 20px;
        
    }
    &.--Contacts{
        margin-bottom: 20px;
        & span{
          width:90%;
          
          margin: auto;
          display: flex;
          & svg{
            padding-right: 5px;
          }
          a{
          width:100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          }
        }
    }
`;

const Info = Styled.span` 
    display: block;
    font-size: 1.063rem;
    font-weight: 500;
    color:var(--color-brand-blue-main);
    vertical-align: middle;
    &.--description{
      white-space: nowrap;
      span{
        font-family:"Arial"; //the font family no work on mac
        vertical-align: middle;
        color: var(--color-brand-grey-secondary);
      }
      svg{
        color: var(--color-brand-grey-secondary);
      }
        &.--contact{
            margin-top:10px;
        }
    }
`;

const AgencyImage = Styled.div`
    img{
        max-width: 191px;
        width: 100%;
    }
     @media screen and (max-width: 767px) {
        width: 158px;
        text-align: center;
        margin:auto;
    }

`;
